import { IServerResponse, IConnectionStatus } from '@/app-modules/server-communications';
import { Observable } from 'rxjs/Observable';
import { AuthenticationResponse, MessageResponse,
         HistoryResponse, UserListResponse, AddUserResponse,
         RemoveUserResponse, ChatPrizeResponse, JackpotWinnerMessageResponse, ArcadeWinnerMessageResponse,
         UserSearchResultResponse, ModifyUserMessageResponse} from '@/components/chat/_domain';
import { ConnectionStatusConnectingResponse, ConnectionStatusConnectedResponse,
        ConnectionStatusConnectionLostResponse, ConnectionStatusDisconnectingResponse,
        ConnectionStatusDisconnectedResponse, ConnectionStatusRetryCircuitBrokenResponse } from '@/app-modules/connection-status';
import { IAuthenticationResponse } from '@/app-modules/server-service';

export class ChatServerResponseStreams {
  public static createChatStreams(stream$: Observable<IServerResponse>, error$: Observable<Error>, connectionStatus$: Observable<IConnectionStatus>): ChatServerResponseStreams {
    return new ChatServerResponseStreams(stream$, error$, connectionStatus$);
  }

  public readonly connectionStatusConnecting$: Observable<{}>;
  public readonly connectionStatusConnected$: Observable<{}>;
  public readonly connectionStatusConnectionLost$: Observable<{}>;
  public readonly connectionStatusDisconnecting$: Observable<{}>;
  public readonly connectionStatusDisconnected$: Observable<{}>;
  public readonly connectionStatusRetryCircuitBroken$: Observable<{}>;
  public readonly error$: Observable<Error>;
  public readonly auth$: Observable<IAuthenticationResponse>;
  public readonly userlist$: Observable<UserListResponse>;
  public readonly adduser$: Observable<AddUserResponse>;
  public readonly removeuser$: Observable<RemoveUserResponse>;
  public readonly message$: Observable<MessageResponse>;
  public readonly history$: Observable<HistoryResponse>;
  public readonly chatPrize$: Observable<ChatPrizeResponse>;
  public readonly jackpotMessage$: Observable<JackpotWinnerMessageResponse>;
  public readonly arcadeWinner$: Observable<ArcadeWinnerMessageResponse>;
  public readonly userSearch$: Observable<UserSearchResultResponse>;
  public readonly modifyUser$: Observable<ModifyUserMessageResponse>;

  constructor(stream$: Observable<IServerResponse>, error$: Observable<Error>, connectionStatus$: Observable<IConnectionStatus>) {
    this.connectionStatusConnecting$ = ConnectionStatusConnectingResponse.asStream(stream$, error$, connectionStatus$);
    this.connectionStatusConnected$ = ConnectionStatusConnectedResponse.asStream(stream$, error$, connectionStatus$);
    this.connectionStatusConnectionLost$ = ConnectionStatusConnectionLostResponse.asStream(stream$, error$, connectionStatus$);
    this.connectionStatusDisconnecting$ = ConnectionStatusDisconnectingResponse.asStream(stream$, error$, connectionStatus$);
    this.connectionStatusDisconnected$ = ConnectionStatusDisconnectedResponse.asStream(stream$, error$, connectionStatus$);
    this.connectionStatusRetryCircuitBroken$ = ConnectionStatusRetryCircuitBrokenResponse.asStream(stream$, error$, connectionStatus$);
    this.error$ = error$;
    this.auth$ = new AuthenticationResponse().asStream(stream$, error$, connectionStatus$);
    this.userlist$ = new UserListResponse().asStream(stream$, error$, connectionStatus$);
    this.adduser$ = new AddUserResponse().asStream(stream$, error$, connectionStatus$);
    this.removeuser$ = new RemoveUserResponse().asStream(stream$, error$, connectionStatus$);
    this.message$ = new MessageResponse().asStream(stream$, error$, connectionStatus$);
    this.history$ = new HistoryResponse().asStream(stream$, error$, connectionStatus$);
    this.chatPrize$ = new ChatPrizeResponse().asStream(stream$, error$, connectionStatus$);
    this.jackpotMessage$ = new JackpotWinnerMessageResponse().asStream(stream$, error$, connectionStatus$);
    this.arcadeWinner$ = new ArcadeWinnerMessageResponse().asStream(stream$, error$, connectionStatus$);
    this.userSearch$ = new UserSearchResultResponse().asStream(stream$, error$, connectionStatus$);
    this.modifyUser$ = new ModifyUserMessageResponse().asStream(stream$, error$, connectionStatus$);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/server/stream-factory.ts